import React, { Component } from 'react';
import { SvgImage } from '.';
import { warningIcon, infoIcon, errorIcon } from '../../style/images';
import { PropTypes } from 'prop-types';
import { translate } from '../services';
import classNames from 'classnames';

export const PopupType = {
  Warning: { icon: warningIcon, className: 'warning' },
  Info: { icon: infoIcon, className: 'info' },
  Error: { icon: errorIcon, className: 'error' }
};

export class PopupMessage extends Component {
  onClick = () => {
    this.props.onClick();
    this.hidePopup();
  }

  hidePopup = () => {
    this.props.hidePopup();
  }

  cancelPopup = () => {
    this.props.onClose && this.props.onClose();
    this.hidePopup();
  }

  render() {
    const { 
      actionText = translate( 'Ok' ), 
      cancelText = translate( 'Dismiss' ), 
      popupType = PopupType.Warning,
      text 
    } = this.props;

    return <div className="popup-message">
      <div className={ classNames( "left", popupType.className ) }>
        <SvgImage source={ popupType.icon }/>
      </div>
      <div className="right">
        <p>{ text.split('\n').map( ( t, i ) => <span key={ i } className="popup-text-line">{ t }</span>) }</p>
        <div className="actions">
        { this.props.onClick && <button onClick={ this.onClick }>{ actionText }</button> }
          <button onClick={ this.cancelPopup }>{ cancelText }</button>
        </div>
      </div>
    </div>;
  }
}

PopupMessage.propTypes = {
  actionText: PropTypes.string,
  cancelText: PropTypes.string,
  hidePopup: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  text: PropTypes.string.isRequired,
  type: PropTypes.oneOf( [PopupType.Warning, PopupType.Info, PopupType.Error, null] )
};
